import jaLocale from 'element-ui/lib/locale/lang/ja'

const ja = {
  message: {
    message: '上記に記載されている事項に同意します',
    agree: '《服务协议》',
    
    hello: 'こんにちは',
    lang: '日本語',
    accoPlaceholder: 'ユーザー名/ 電話番号を入力してください',
    passPlaceholder: 'パスワードを入力してください',
    loginBtnText: 'ログイン',
    logOutText: 'ログアウト',
    
    menuText: {
      custManageTitle: 'カスタマ管理',
      addManageText: '住所管理',
      orderManageTitle: '注文管理',
      ordercheckTitle: '注文内容を表示',
      signatureFormTitle: '受領書管理',
      deliverymanTitle: 'ドライバー管理',
      deliveryDetailTitle: '配送明細',
      distributionStatisticsTitle: '配送統計',
      temporaryWorkersTitle: 'アルバイト管理',
      clockStatisticsTitle: 'カード集計',
      containerTitle: '発注--ORDER',
      containerQueryTitle: '貨物情報検索',
      historyOrdersTitle: '注文履歴',
      formalWorkersTitle: '正社員管理',
      reservedCargoManagement: '保留貨物管理',
      amazonOrderTitle: '貨物配送明細',
      DiaoDuTitle: '配車管理',
		orderRecycleBinTitle:'ゴミ箱',
		xiaoBaoTitle:'GO-FOR配送明細',
		xiaoBaoYuanGongTitle:'GO-FOR配達員',
		BaoGuoTitle:'包裹管理',
		ChildAccountTitle:'子账户管理',
			BLTitle:'BL、搬出票',
    },
    
    custManageText: 'カスタマ管理',
    addManageText: '住所管理',
    custSearchPlaceholder1: 'クライアント名/ログイン名',
    custSearchPlaceholder: 'お客様の名前を入力してください',
    searchBtnText: '検索',
    addCustBtnText: '新規カスタマ',
    updateCustBtnText: '修正クライアント',
    customTableTitle1: '番号',
    customTableTitle2: 'カスタマ名称',
    customTableTitle3: 'パスワード',
    customTableTitle4: '権限管理',
    customTableTitle5: '編集',
		customTableTitle6: '追加SKU',
		addFileFBA: 'FBA・SKUラベル添付',

    customTableContent: '見る',
    cancleText: 'キャンセル',
    confirmText: '確定',
    newCustomerName: 'お客様名前',
    newCustomerLoginName: 'ログイン名',
    newCustomerPhone: '電話番号',
    newCustomerSpecial: '特殊テンプレート',
    newCustomerPassword: 'パスワード',
    newCustomerCompany: '取引先会社',
    newCustomerEmail: 'メール',
    newCustomerProvince: '県',
    newCustomerCity: '市',
    newCustomerDetailAddress: '詳しい住所',
    newCustomerPermission: '権限設置',
    newCustomerIsAdmin: '管理者権限',
		newCustomerIsDriverAdmin: 'ドライバー管理権限',
		newCustomerIsDriverPosition: '管理地域',
		createClockInfo:'打刻追加',
		createClockDutyInfo: '勤務日外打刻追加',
		clockTimeInfoTitle:'打刻時間',
		clockPlaceInfoTitle:'打刻場所',
		
		tokyoOffice:'関東集荷依頼',
		osakaOffice:'関西・中部集荷依頼',
		KWS1Office:'JHSS藤井寺・保税・4KWS1',
		SWH7Office:'JHSS市川・保税・2SWH7',
		FWX6Office:'JHSS大田・保税・1FWX6',
		selectTokyo:'東京',
		selectYokohama:'横浜',
		selectOsaka:'大阪',
		selectNagoya:'名古屋',
		selectKobe:'神戸',
		selectOther:'その他',
		
    //正式员工管理
    EmployeeNo:'社員番号',
    BusinessOffice:'営業所',
		isJob:'在職',
		isQuit:'離職',
		NoSiJiTitle:'非ドライバー',

    placeholder: '入力してください',
    permission: [{
      pkid: 'F00',
      label: 'カスタマ管理',
    }, {
      pkid: 'F01',
      label: '住所管理',
    }, {
      pkid: 'F02',
      label: '注文管理',
    }, {
      pkid: 'F03',
      label: '注文内容を表示',
    }, {
      pkid: 'F04',
      label: '受領書管理',
    }, {
      pkid: 'F05',
      label: '配達員管理',
    }, {
      pkid: 'F06',
      label: '配送明細',
    }, {
      pkid: 'F07',
      label: '配送統計',
    }, {
      pkid: 'F08',
      label: '非正規労働者管理',
    }, {
      pkid: 'F09',
      label: '発注--ORDER',
    }, {
      pkid: 'F10',
      label: '貨物情報検索'
    }, {
      pkid: 'F11',
      label: '注文履歴'
    }, {
      pkid: 'F12',
      label: '正社員管理'
    }, {
      pkid: 'F13',
      label: '保留貨物管理'
    }, {
      pkid: 'F14',
      label: '貨物配送明細'
    }, {
      pkid: 'F15',
      label: '配車管理'
    }, {
			pkid: 'F16',
			label: 'ゴミ箱'
		}, {
			pkid: 'F17',
			label: '小包订单'

		}, {
			pkid: 'F20',
			label: '子账户管理'

		}, {
			pkid: 'F24',
			label: 'BL、搬出票'

		}],
    prompt: 'この操作により、カスタマデータが完全に削除され、続行しますか？',
    promptTitle: '提示',
    addressNameTitle: 'カスタマ名',
    addressPhoneTitle: '電話番号',
    addresseeNameTitle: '受取人',
    addresseePhoneTitle: '受取人電話番号',
    provienceAddressTitle: '県/省',
    cityAddressTitle: '市',
    detailAddressTitle: '詳しい住所',
    addresseeAddressTitle: 'お届け先',
    addressAddNameTitle: '名前追加',
    addressAddTimeTitle: '時間追加',
    addAddresseeBtnText: '新規住所',
    updateAddresseeBtnText: '住所を修正する',
    addresseePrompt: 'この操作により、カスタマ住所が完全に削除され、続行しますか？',
    canclePrompt: '取消',
    
    orderSearchPlaceholder: '注文番号を入力してください',
    orderSearchPlaceholder2: '差出人/宛名を入力してください',
    orderStatusList: [{ value: 0, label: '配送中' }, { value: 1, label: '輸送中' }, { value: 2, label: 'お届け済み' }, { value: 3, label: '廃棄した' }],
	
	WAREHOUSEList: [{
		value: '市川',
		label: '市川'
	}, {
		value: '大田',
		label: '大田'
	}, {
		value: '藤井寺',
		label: '藤井寺'
	}],
    orderTimeStartHolder: '開始時間',
    orderTimeEndHolder: '終了時間',
    orderSearchPlaceholder3: '受信省を選択してください',
    orderSearchPlaceholder4: '備考を入力してください',
    addOrderBtnText: '新規注文',
    updateOrderBtnText: '注文の修正',
    orderTableTitle1: '注文番号',
    orderTableTitle2: 'バーコード',
    orderTableTitle3: '配送状況',
    orderTableTitle4: '差出会社',
    orderTableTitle5: '差出人',
    orderTableTitle6: '電話番号',
    orderTableTitle7: '貨物数量',
    orderTableTitle8: '貨物重量',
    orderTableTitle9: '貨物体積',
    orderTableTitle10: '注文状況',
    orderTableTitle11: '作成時間',
    orderState0: '配送中',
    orderState1: '輸送中',
    orderState2: 'お届け済み',
    orderState3: '廃棄した',
    orderTableCheckTitle: '見る',
    senderPhoneTitle: '差出人電話番号',
    senderEmailTitle: '差出人メールアドレス',
    senderProvienceTitle: '寄件県/省',
    senderCityTitle: '寄件市',
    senderAddressTitle: '差出宛',
    addresseeInfoTitle: 'あて先情報',
    addresseeProvienceTitle: '收件県/省',
    addresseeCityTitle: '收件市',
    addresseeTitle: 'お届け先',
    addresseeCompanyTitle: 'お届け先会社名',
    addresseeNameTitle: '受取人名前',
    addresseePhoneTitle: '受取人電話番号',
    addresseeEamilTitle: 'あて先メールアドレス',
    orderRemarkTitle: '貨物番号',

    orderPrompt: 'この操作により、注文が完全に削除され、続行しますか？',
    orderPromptYs: 'この操作により、プリセット状態が永続的に削除されます。続行するかどうか？',
    setPPrompt: '受領書すべて印刷しましたか?',
    orderCanclePrompt: 'この作業はこの注文を永久に無効にし、継続するかどうか?',
    downLoadExcel: 'ダウンロード用テンプレート',
    importExcelTitle: 'excelを導入',
    selectExcel: '選択ファイル',
    importExcelError: 'ファイルのアップロードに失敗',
    importExcelCheck: '導入文書を見る',
    confirmImportExcel: '導入を確定する',
    setOrdersContainer: 'コンテナを設置する',
    delOrderText: '削除',
		savesOrderText: 'ほぞんする',
    
    
    goodsNo:'貨物番号',
    amazonCode:'Amazon  code',
    caseNo:'箱番号',
    FBATagNO:'外装FBAラベル',
    SKUTagNo:'商品SKUラベル',
    SKUNumber:'数量',
    tradeName:'商品名',
    productRemarks:'商品備考',
    commodityPhotos:'商品写真',
    labelingRemarks:'備考欄',

    
    backText: '戻る',
    addNewLogisticsText: '配送状況追加',
    updateLogisticsText: '配送状況修正',
    goodsStatusTitle: '貨物状況',
    deliveryStatusTitle: '配送状況',
    positionTitle: '今のところ',
    logisticsImgTitle: '物流写真',
    dateTitle: '配送日付',
    uploadLogisticsImg: '画像をアップロードする',
    logisticsPrompt: 'この操作により、貨物配送情報が完全に削除され、続行しますか？',
    startLogistics: '配送を始める',
    endlogistics: 'お届け済み',
    orderHasCompleteText: '注文が完了したことを確認する',
    
    signatureSearchPlaceholder: '受領書の名称を入力してください',
    signatureSearchPlaceholder2: '送り状番号を入力してください',
    addSignatureBtnText: '新規受領書',
    signatureFormName: '受領書の名称',
    signatureNumTitle: '送り状番号',
    signatureOrderTitle: '注文',
    signatureOrderImgTitle: '写真',
    signatureStateTitle: '状況',
    signatureAddUserTitle: '作成者',
    signatureAddTimeTitle: '作成時間',
    signaturePrompt: 'この操作により、受領書が完全に削除され、続行しますか？',
    signatureNotOrder: '追加',
    signatureHasOrder: '見る',
    signatureStatusTitle1: '配送中',
    signatureStatusTitle2: 'お届け済み',
    signatureInsertOrderSearchPlaceholder: 'キーワードを入力してください',
    signatureInsertOrderText: '注文を追加する',
    signatureInsertImgText: '写真を追加する',
    signatureInsertTipsText: '注文を選んでください',
    signatureInsertPrompt: '注文を追加かどうか',
    uploadImgErrorFormatText: 'アプロードする写真はJPGしかない',
    uploadImgErrorTipsText: 'アプロード失敗、もう一回やり直してください',
    uploadImgNoImgTitle: '写真を選んでアプロードしてください。',
    signatureInsertImgPrompt: '写真を追加しますか',
    endSignatureTitle: '受領書を完了しますか？',
    signOrderTitleText: '受領書',
    
    deliveryAreaTitle: '配送範囲を選択してください',
    addDeliveryManTitle: '配送員の新設',
    updateDeliveryManTitle: '配達人を訂正する',
    deliveryAccountTitle: 'アカウントを登録する',
    deliveryNameTitle: '配達人の氏名',
    deliveryPasswordTitle: 'ログインパスワード',
    deliveryAreaTitle: '配送範囲',
    deliveryPhoneTitle: '携帯電話番号',
    deliveryEmailTitle: 'メール',
    delDeliveryPrompt: 'この作業はこの配送者を永久に削除し,継続するかどうか。',
    
    deliveryManTitle: '配達人',
    deliveryTimeTitle: '配送時間',
    deliveryNumTitle: '配送数',
    exportText: 'エクスポート',
    
    tempeoraryNameTitle: 'パート従業員の氏名',
    attendanceTimeTitle: '日付',
    addTempeoraryManTitle: 'アルバイトの追加',
    updateTempeoraryManTitle: '臨時社員を改組する',
    todayClockNum: '本日出勤の人数',
    tempeoraryNameTitle: '名前',
    tempeoraryPhoneTitle: '携帯電話番号',
    tempeoraryEmailTitle: 'メール',
    tempeoraryAccountTitle: 'アカウント',
    tempeoraryPasswordTitle: 'パスワード',
    airportWageTitle: '関空出勤の交通費',
    warehouseWageTitle: '大阪倉庫出勤の交通費',
    dailyWageTitle: '補助金の上限',
    hourlyWageTitle: '時給',
    monthlyPassTitle: '交通費定期券',
    attendanceNumTitle: '総出勤回数',
    attendanceHoursTitle: '合計勤務時間',
    clockInDetailTitle: '出勤明細',
		driverArea:'司机所属地区',
    delTempeoraryPeompt: 'この作業を永久に削除し、継続するかどうか。',
		delClockInfo: 'この打刻記録を完全に削除しますか？',
		delClockmessage:'このカードの明細は削除規則に適合していません',
    clockInAddTitle: '出勤場所',
    punchInTimeTitle: '出勤時間',
    punchOutTimeTitle: '退勤時間',
    manHourTitle: '勤務時間/日',
    strippingStartTime: '開封開始時刻',
		strippingTime: '開封時刻',
    strippingEndTime: '解体終了時間',
    strippingSize: 'たんすサイズをはずす',
    strippingNum: '櫃の数',
    littleSize: '小型',
    bigSize: '大きい寸法',
		
		trailerArrangement:'ドレー手配',
		containerTransportWays1:'JHSSドレー手配-  JHSSデバン',
		containerTransportWays11:'JHSSドレー手配- JHSSバン積め',
		containerTransportWays2:'JHSSにドレー持込-  JHSSデバン',
		containerTransportWays21:'JHSSにドレー持込- JHSSバン積め',
		containerTransportWays3:'ドレー直送-',

    
    containerTitle: 'Order 情報',
    week: ['月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日', '日曜日'],
    noEnterContainersNum: 'コンテナの数量は未登録です',
    newContainerTitle: '新規注文',
    modifyContainerTitle: '注文の修正',
    // containerOrderCity: '都市',
    containerOrderCity: '営業所',
    containerJOBNO: 'JOB NO',
    containerCreater: '担当者',
    containerOrderModel: '荷種類',
    containerGoodsModel: 'カーゴタイプ',
    litijin: '立替金',
    containerText: 'コンテナ',
    containerOrderNumber: 'コンテナ番号',
    placeOfDelivery: '集荷先',
    containerOrderArrivalDate: '作業時間',
    containerStripping: 'コンテナ作業時間',
    deliveryDate: '集荷可能時間帯',
		trailerArrangement:'ドレー手配',
    hasSpecifyTime: 'ある',
    noSpecifyTime: '無',
    specifyTime: '時間を指定する',
    containerOrderCustomerID: '顧客コード',
    containerOrderCustomer: '会社名',
    customerDedicatedNum: 'お客様専用番号',
    containerOrderNum: '数量',
    containerOrderVolume: 'M3数',
    containerOrderWeight: '重量',
    containerOrderRemark: '備考',
    containerOrderAttacherFile: '添付ファイル',
    addFileText: '書類を添付する',
    noAttachment: '添付ファイルなし',
    goodsStatus: '到着状況',
    setGoodsStatus: '設置',
    hasArrive: '到着した',
    notArrive: '未到着',
    containerCondition: '正常/異常',
    conditionAbnormal: '異常かどうか',
    normalCondition: '正常',
    abnormalCondition: '異常',
    adnormalRemark: '異常説明',
    abnormalUpload: '異常時アップロード',
    exportDatePlaceholder: '選んでください',
    kantoReceipt: '関東受領書',
    kansaiReceipt: '関西受領書',
    containerReceipt: '受領書',
    containerReturnReceipt: '捺印済受領書',
    FBASKUtally: 'FBA/SKUラベル',
    billTitle: '請求書',
    uploadReceipt: 'ファイルをアップロードする',
    sendEmailPeompt: 'メール送信の有無?',
    containerOrdersDetails: '注文の明細',
    numberUnitPlaceholder: '数量単位で記入してください！',
    downloadNumber: 'ダウンロード状況',
    download: 'ファイルをダウンロード',
		downloadCode: '二次元コードをダウンロード',

    affirmText: '作業完了',
    confirmPeople: '確認者',
    affirmTime: '完了時間',
    remarkFillSuccess: '備考記入完了',
		SKUInfoFillSuccess: 'SKU記入完了',

    tallyName: 'ラベル名',
    cancelAffirmText: '作業キャンセル',
    hasAffirm: '作業完了',
    notAffirm: '未作業',
    uploadTimetext: '作成時間',
    
    containerQueryTitle1: '日付',
    createContainerOrder: 'コンテナ情報の更新',
    arrivePort: '港につく',
    inspection: '検査',
    
    orderHistoryState: [{ value: '0', label: 'ファイリング済み' }, { value: '1', label: '削除済み' }],
    
    addformalWorkersTitle: '正社員の追加',
    updateformalWorkersTitle: '正社員の見直し',
    // 保留货物管理
    placeholderKeyword: 'キーワードを入力してください',
    placeholderColumn: '検索列を選択してください',
    createCargoTable: '創建保留在庫表',
    deleteCargoTable: '削除保留在庫表',
    
    mainOrDeputyPlaceholder: 'MB/L、/HB/L番号を入力してください',
    queryBtnText: '検索',
    uploadBtnText: 'アップロード',
    signInTimeStartPlaceholder: '開始時間作成',
    signInTimeEndPlaceholder: '終了時間作成',
    amazonOrderStatus: '状態を選んでください',
    signInOrderStatus1: '異常',
    signInOrderStatus2: '正常',
    containerOrderLogisticsStatus: '物流状態を選択してください',
    orderTemplateDialogTitle: 'テンプレート　ダウンロード',
    orderTemplateUploadTitle: 'テンプレート　アップロード',
    templateTypeTitle: 'テンプレートの種類',
    specialTemplate: 'スペシャル　テンプレート',
    normalTemplate: 'ノーマル　テンプレート',
    FCSpecialTemplate: 'FC - スペシャル　テンプレート',
    batchUpdateLogisticsInfo: '貨物追跡一括設定',
    batchSetStatus: '貨物状態一括設定',
    batchDelete: '一括削除',
    batchDeleteYs: '一括削除プリセット',
    createSignInImg: '受領書を作成',
    signInImgName: 'ログイン名',
    signInOrderCustomer: 'カスタマ',
    uploadFileTitle: 'ファイル',
    mainOrderNum: 'MARK',
    deputyOrderNum: '貨物番号',

    numInOrder: '個数',
    addressInOrder: '住所',
    estimatedTimeArrival: '集荷日',
    uploadOrderFileError: 'アップロードしたファイルはエラーになっていますので、もう一回操作してください。',
    uploadOrderNoFileError: 'アップロードしたファイルに内容ありません。',
    checkLogisticsText: '貨物を追跡する',
    goodsDescription: '貨物状況確認',
    deliverySituation: '配送状況確認',
    deliverySituationY: 'プリセット状態',
    logisticsDate: '日付',
    setOrderStatus: '状態の設定',
    orderStatusRemark: '備考',
    deliverySituation1: '貨物集荷',
    deliverySituation2: '配達中',
    deliverySituation3: '配達完了',
    deliverySituation4: '持ち戻り',
    deliverySituation5: '受取拒否',
    deliverySituation6: '再配達',
    deliverySituation7: '未更新',
    
    queryPlaceholder1: 'お問い合せ番号を半角英数字にて入力し、検索してください',
    queryPlaceholder2: '複数の番号を検索する場合、「,」を入力してください。',
    orderDetails: '注文詳細',
    deliveryAddress: '配達先',
    deliveryOrderTitle: 'JHSS送り状',
    querySuborderTitle: '送り状番号',
    delOrderLogisticsPrompt: 'この作業はこの物流情報を永久に削除し,継続するかどうか?',
	
	
	IsSiJi:'ドライバー',
	IsExternalSiJi:'外部司机',
	SiJiTitle:'ドライバー',
	DriverAreaAll:'全部',
	DriverAreaTokyo:'東京',
	DriverAreaOsaka:'大阪',
	DiaoDuTitle:'配車管理',
	QuHuoTitle: '引取',
	SongHuoTitle: '納品',
	AddCarTitle: '車両追加',
	CarNoTitle: '車番',
	SongHuoXingChengTitle: '行程詳細',
	PleaseAddCarNo: '車番を入力してください',
	setStatus: '設定',
	LeiXingTitle: '種類',
	SetOrderAndXingChengTitle: '行程追加',
	XingChengTimeTitle: '行程時間',
	XingChengTitle1: '行程1',
	XingChengTitle2: '行程2',
	XingChengTitle3: '行程3',
	XingChengTitle4: '行程4',
	XingChengTitle5: '行程5',
	XingChengTitle6: '行程6',
	XingChengTitle7: '行程7',
	XingChengTitle8: '行程8',
	XingChengTitle9: '行程9',
	XingChengTitle10: '行程10',
	XingChengTitle11: '行程11',
	XingChengTitle12: '行程12',
	XingChengTitle13: '行程13',
	XingChengTitle14: '行程14',
	XingChengTitle15: '行程15',
    CarAndSiJiTitle: '車番とドライバー情報を入力してください',
		
	HDS: 'HDS货物',
	ShouJianYouBian: 'お届け先郵便番号',
	ShouJianSheng: 'お届け先住所１',
	ShouJianShi: '收件市',
	ShouJianDiZhi: 'お届け先住所２',
	ShouJianGongSi: '收件公司名',
	ShouJianName: 'お届け先名',
	ShouJianPhone: 'お届け先電話番号',
	Mark: 'MARK',
	HuoWuCode: '货物单号',
	HuoWuPc: '個数(pc)',
	HuoWuKg: '重量(kg)',
	HUoWuM: '三辺和(cm)',
	KeHuCode: '客户代码',
	JiJianPeo: 'ご依頼主名称',
	JiJianPhone: 'ご依頼主電話番号',
	JiJianYouBian: 'ご依頼主郵便番号',
	JiJianDiZhi: 'ご依頼主住所',
	UpdateExcelTitle:'更新数据',
	SystemOrderNum:'GOFOR番号',
		
	ISCANDOOR:'置き配可能かどうか',
	SENDTYPE:'配達方法',
	CUSTOMERNO:'お客様管理番号',
	
	BaoGuoName:'包裹名称',
	BaoGuoQrcode:'包裹二维码编号',
	BaoGuoCode:'区域编号',
	CityName:'所属城市',
	AreaSuoShuName:'所属区域',
	AreaName:'区域名称',
	AreaOrderCode:'区域订单码',
	AddTitle:'新增',
	EditTitle:'编辑',
	SortidTitle:'序号',
	BaoGuoAddTitle1:'请输入包裹名称',
	BaoGuoAddTitle2:'请输入包裹序号',
	BaoGuoAddTitle3:'请输入包裹所属区域',
	
		
	GuiDangDingdan:'注文履歴',
	ThreeMonthOrder:'3カ月前のオーダー履歴',
	GuiDangDingdanBack:'「発注--ORDER」に戻る',
	PrintMulOrdersText:'一括印刷',
		XuKeText:"許可状況",
		HaveXuKeText:"許可済",
		NoXuKeText:"未許可",
		ImpSumOrder:"オーダーの一括作成",
		chaiguiTime:"デバン時間",
		weicaozuoTitle:"未",
		yididaTitle:"到着",
		yianpaiTitle:"完了",//手配済
		yiwanchengTitle:"出庫済",//完了
		xukejihuowu:"許可済貨物",		
		WAREHOUSE:"倉庫",
		HBLCOMPANY:"HBL 会社",
		SUMSL:"总数量",
		SUMZL:"总重量",
		SUMTJ:"总体积",
		
		SHIPNAME:"本船名",
		VOY:"VOY.",
		PlaceofLoading:"Place of Loading",
		PlaceofDelivery:"Place of Delivery",
		ETA:"ETA",
		MBLNO:"MBL NO",
		Shipper:"Shipper",
		Consignee:"Consignee",
		pinming:"品名",
		HBLNO:"HBL NO",
		Num:"個数",
		UNIT:"数量単位",
		Zl:"重量",
		NaPin:"納品先",
		M3:"M3",
		dandang:"JHSS担当者",
		banchudate:"搬出予定日",
		AllPrint:"批量印刷搬出票",
		OnePrint:"分单下载搬出票",
		AllPrintBL:"批量印刷HBL、HAN",			 
			 batchSetInfo: '批量设置'
		
  },
  ...jaLocale
}

export default ja